var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.8,125.6l184.3,184.3c12.8,12.7,12.8,33.3,0,45.9l-30.6,30.6c-12.7,12.7-33.3,12.7-45.9,0L223.9,255.8 L93.3,386.4c-12.7,12.7-33.3,12.7-45.9,0l-30.6-30.6c-12.7-12.7-12.7-33.3,0-45.9L201,125.6C213.5,112.8,234.1,112.8,246.8,125.6 L246.8,125.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.676d47473e0fe9b4d9d2fb8c2ab92fdc.svg";
export { ForwardRef as ReactComponent };